import type { SVGProps } from 'react';

export const SvgImgIllustKabukatsu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={176} height={150} viewBox="0 0 176 150" fill="none" {...props}>
    <path
      fill="#fff"
      d="M71.36 123.059c2.45 1.407 2.46 3.7.034 5.119-2.427 1.407-6.382 1.407-8.83 0l-6.017-3.468c-2.45-1.408-2.46-3.701-.034-5.119 2.427-1.408 6.383-1.408 8.831 0zM59.294 129.662c2.449 1.407 2.46 3.701.034 5.119-2.427 1.407-6.383 1.407-8.831 0l-6.017-3.468c-2.448-1.407-2.46-3.701-.033-5.119 2.426-1.407 6.382-1.407 8.83 0z"
    />
    <path
      fill="#FADDD6"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M43.35 83.391c-.92 16.144 1.396 43.479 1.396 43.479 1.363 1.606 4.41 2.249 6.803.376L53.2 91.081h2.66l.797 29.839c2.116 1.761 4.399 1.761 6.427-.023 0 0 .642-15.822 2.16-34.89l-7.069-5.873c-9.44 3.124-5.485 6.648-14.836 3.257z"
    />
    <path
      fill="#FF9595"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m65.643 80.644 3.38-3.236.742 16.465c-2.415 5.197-7.656 7.258-13.451 9.64-11.424 4.698-15.822-.765-15.822-.765l.664-23.157s14.848 4.222 24.487 1.041z"
    />
    <path
      fill="#F9EAAC"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m77.854 59.06-7.091-3.258-9.296 10.515c-1.374 6.46 8.576 9.296 11.069 4.221 1.96-3.457 5.318-11.479 5.318-11.479"
    />
    <path
      fill="#F9EAAC"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M40.48 84.743c3.446 6.67 24.454 3.335 29.717-7.202l-.953-9.518s2.471-7.645.178-15.922c-.72-2.581-3.8-4.177-5.54-5.761-1.729-1.574-7.413-3.225-7.413-3.225l-12.11 3.224c-4.056 2.538-7.99 8.189-7.269 12.92.41 2.737 3.7 14.315 3.7 14.315z"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M69.965 58.339a4.75 4.75 0 0 1-4.742 4.742 4.75 4.75 0 0 1-4.743-4.742 4.75 4.75 0 0 1 4.743-4.742 4.75 4.75 0 0 1 4.742 4.742"
    />
    <path
      fill="#F9EAAC"
      d="M47.45 66.106c3.756-.92 12.299-6.98 12.299-6.98 2.56.92 3.745 1.994 4.587 5.041-2.427 2.926-5.064 5.85-7.446 8.078-3.8 3.18-8.266 5.761-12.775 3.025-1.84-1.12-4.51-5.43-4.92-7.535"
    />
    <path
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M47.45 66.106c3.756-.92 12.299-6.98 12.299-6.98 2.56.92 3.745 1.994 4.587 5.041-2.427 2.926-5.064 5.85-7.446 8.078-3.8 3.18-8.266 5.761-12.775 3.025-1.84-1.12-4.51-5.43-4.92-7.535"
    />
    <path
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M47.45 66.106c3.756-.92 12.299-6.98 12.299-6.98 2.56.92 3.745 1.994 4.587 5.041-2.427 2.926-5.064 5.85-7.446 8.078-3.8 3.18-8.266 5.761-12.775 3.025-1.84-1.12-4.51-5.43-4.92-7.535"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeMiterlimit={10}
      strokeWidth={2.2}
      d="M66.94 47.524c-.188.111-.343.4-.343.62l.044 17.54c0 .233.155.322.343.211l7.17-4.365c.188-.111.343-.4.343-.621l-.045-17.54c0-.232-.155-.321-.343-.21z"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M80.657 55.037a4.75 4.75 0 0 1-4.742 4.743 4.75 4.75 0 0 1-4.742-4.743 4.75 4.75 0 0 1 4.742-4.742 4.75 4.75 0 0 1 4.742 4.742"
    />
    <path
      fill="#FF0019"
      d="m60.369 45.01.875 8.542c.045.41.532.599.842.322l3.203-2.881q.15-.133.166-.333c.1-1.362.565-9.584-.964-17.683-1.12-5.961-9.729-5.784-9.729-5.784l5.596 17.817z"
    />
    <path
      fill="#FADDD6"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M51.849 48.533c-6.652 0-12.044-5.392-12.044-12.044 0-6.651 5.392-12.044 12.044-12.044 6.651 0 12.044 5.393 12.044 12.044S58.5 48.533 51.849 48.533"
    />
    <path
      fill="#FF0019"
      d="M50.586 38.783a1.872 1.872 0 1 1 0-3.745 1.872 1.872 0 0 1 0 3.745M57.954 37.309a1.872 1.872 0 1 1 0-3.745 1.872 1.872 0 0 1 0 3.745"
    />
    <path
      fill="#FF0019"
      d="M44.414 36.91s10.348-3.844 12.265-11.102c0 0-.942-2.393-6.87-1.673-8.841 1.075-11.102 8.798-11.755 12.775-.976 5.95 2.26 17.263 2.78 19.014a.48.48 0 0 0 .3.321l5.296 2.061a.507.507 0 0 0 .687-.532z"
    />
    <path fill="#FF0019" d="M55.084 28.157s3.424 5.795 8.155 6.88l-1.196-5.694-5.962-4.898z" />
    <path
      fill="#EDA94F"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m143.652 97.434.078 25.575-28.822 16.638-.071-25.569z"
    />
    <path
      fill="#EDD14F"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m114.908 139.647-41.51-24.124-.077-25.569 41.516 24.124z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M114.837 114.077 73.321 89.954l28.822-16.644 41.51 24.123z"
    />
    <path
      fill="#ABDCE9"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M114.843 116.401 73.321 92.277v-2.323l41.516 24.124zM114.908 139.647l-41.51-24.123-.077-2.324 41.581 24.124z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m143.652 97.434.007 2.33-28.816 16.637-.006-2.323z"
    />
    <path
      fill="#70C0DB"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m143.723 120.686.007 2.323-28.822 16.637-.007-2.323z"
    />
    <path
      fill="#FBDED7"
      d="M79.516 76.658 76.1 79.775c1.988.64 2.356 2.291.82 3.692-1.536 1.4-4.395 2.02-6.383 1.38l-3.413 3.118L90.9 95.6l12.397-11.3-23.775-7.635z"
    />
    <path
      fill="#fff"
      d="m103.29 84.294-12.397 11.3 9.429 3.027 3.414-3.117c-1.988-.64-2.356-2.291-.82-3.692 1.536-1.4 4.395-2.02 6.383-1.381l3.414-3.117-9.429-3.027z"
    />
    <path
      fill="#FF0019"
      d="M102.787 85.616a.742.742 0 0 1-.658-1.271l.548-.497a.743.743 0 0 1 1.046.045.743.743 0 0 1-.045 1.046l-.549.497a.7.7 0 0 1-.342.174zM93.901 93.715a.743.743 0 0 1-.658-1.271l.987-.897a.743.743 0 0 1 1.046.045.743.743 0 0 1-.046 1.046l-.987.897a.7.7 0 0 1-.342.174zm2.962-2.697a.743.743 0 0 1-.658-1.271l.987-.898a.75.75 0 0 1 1.046.045.743.743 0 0 1-.045 1.046l-.988.897a.7.7 0 0 1-.342.174zm2.962-2.698a.743.743 0 0 1-.658-1.271l.988-.897a.74.74 0 0 1 1.045.045.74.74 0 0 1-.045 1.045l-.988.897a.7.7 0 0 1-.342.175zM91.384 96.013a.743.743 0 0 1-.658-1.271l.542-.498a.743.743 0 0 1 1.045.046.743.743 0 0 1-.045 1.045l-.542.497a.7.7 0 0 1-.342.174z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m112.719 87.32-3.414 3.117c-1.987-.639-4.846-.02-6.382 1.381-1.536 1.4-1.168 3.053.819 3.692l-3.414 3.117-33.204-10.668 3.415-3.117c1.987.639 4.846.02 6.382-1.381 1.536-1.4 1.168-3.053-.82-3.692l3.415-3.117z"
    />
    <path
      fill="#FBDED7"
      d="m86.226 84.272-2.697 3.75c2.08.213 2.78 1.752 1.563 3.444-1.21 1.69-3.88 2.884-5.96 2.671l-2.697 3.751 24.84 2.557 9.789-13.622-24.84-2.557z"
    />
    <path
      fill="#fff"
      d="m111.066 86.828-9.788 13.622 9.849 1.014 2.698-3.75c-2.081-.213-2.781-1.752-1.564-3.445 1.211-1.689 3.879-2.883 5.96-2.67l2.697-3.751-9.849-1.014z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m120.922 87.84-2.697 3.75c-2.081-.212-4.75.982-5.961 2.671-1.21 1.69-.511 3.23 1.564 3.444l-2.697 3.751-34.696-3.568 2.697-3.75c2.081.212 4.75-.982 5.96-2.672 1.212-1.69.512-3.229-1.563-3.444l2.697-3.75z"
    />
    <path
      fill="#FBDED7"
      d="m122.746 91.056-3.549 2.956c1.962.73 2.252 2.394.652 3.724-1.601 1.33-4.479 1.82-6.441 1.09l-3.55 2.956 23.408 8.7 12.888-10.733-23.408-8.7z"
    />
    <path
      fill="#fff"
      d="m146.153 99.75-12.888 10.732 9.287 3.447 3.549-2.956c-1.961-.729-2.252-2.394-.651-3.724 1.6-1.329 4.478-1.82 6.44-1.091l3.55-2.955-9.287-3.447z"
    />
    <path
      fill="#FF0019"
      stroke="#FF001A"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M145.27 101.304a.71.71 0 0 1-.674-.251.714.714 0 0 1 .095-1.013l.553-.46a.72.72 0 0 1 .919 1.108l-.554.459a.7.7 0 0 1-.339.157ZM136.262 108.802a.7.7 0 0 1-.673-.252.713.713 0 0 1 .094-1.013l1-.83a.72.72 0 0 1 1.013.095.71.71 0 0 1-.095 1.012l-1 .831a.74.74 0 0 1-.339.157Zm3-2.497a.7.7 0 0 1-.673-.252.713.713 0 0 1 .094-1.013l1-.83a.72.72 0 0 1 1.013.094.713.713 0 0 1-.094 1.013l-1 .83a.73.73 0 0 1-.34.158Zm3.007-2.504a.7.7 0 0 1-.673-.251.713.713 0 0 1 .094-1.013l1-.83a.72.72 0 0 1 1.013.094.71.71 0 0 1-.095 1.013l-1 .83a.7.7 0 0 1-.339.157ZM133.708 110.927a.71.71 0 0 1-.673-.251.72.72 0 0 1 .095-1.013l.553-.459a.72.72 0 1 1 .919 1.107l-.554.459a.73.73 0 0 1-.34.157Z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m155.44 103.201-3.549 2.956c-1.962-.729-4.84-.239-6.441 1.091-1.6 1.329-1.303 3.001.652 3.724l-3.549 2.955-32.695-12.145 3.55-2.956c1.962.73 4.84.239 6.441-1.09s1.303-3.002-.652-3.725l3.549-2.955z"
    />
    <path
      fill="#FBDED7"
      d="m108.148 90.966-4.311 1.665c1.62 1.316 1.362 2.988-.574 3.737-1.943.748-4.828.284-6.448-1.033L92.505 97l19.386 15.74 15.65-6.034-19.387-15.74z"
    />
    <path
      fill="#fff"
      d="m127.534 106.706-15.65 6.034 7.687 6.241 4.311-1.665c-1.62-1.317-1.362-2.988.574-3.737 1.943-.748 4.827-.284 6.447 1.033l4.311-1.665-7.686-6.241z"
    />
    <path
      fill="#FF0019"
      stroke="#FF001A"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M126.281 107.871a.726.726 0 0 1-.151-1.391l.676-.259a.727.727 0 0 1 .936.411.73.73 0 0 1-.411.936l-.677.259a.7.7 0 0 1-.373.038zM115.286 112.107a.72.72 0 0 1-.563-.455.73.73 0 0 1 .411-.936l1.221-.468a.72.72 0 0 1 .935.411.726.726 0 0 1-.411.936l-1.22.468a.7.7 0 0 1-.373.038zm3.667-1.41a.726.726 0 0 1-.151-1.391l1.22-.468a.722.722 0 1 1 .525 1.347l-1.221.468a.7.7 0 0 1-.373.038zm3.661-1.416a.726.726 0 0 1-.151-1.391l1.22-.468a.722.722 0 1 1 .525 1.347l-1.221.468a.7.7 0 0 1-.373.038zM112.169 113.309a.727.727 0 0 1-.152-1.392l.677-.259a.722.722 0 1 1 .525 1.347l-.677.259a.7.7 0 0 1-.373.038z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m135.221 112.953-4.311 1.665c-1.62-1.316-4.511-1.781-6.447-1.032-1.943.748-2.194 2.42-.575 3.736l-4.311 1.666L92.504 97l4.311-1.665c1.62 1.317 4.512 1.781 6.448 1.033 1.936-.75 2.2-2.42.574-3.737l4.311-1.665z"
    />
    <path
      fill="#ABDCE9"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m118.294 96.684-41.51-24.123.75-2.079 41.509 24.124z"
    />
    <path
      fill="#EDA94F"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M131.776 78.414c2.272-1.31 4.569-2.02 6.718-1.956 7.048.207 9.771 8.667 6.08 18.903l-.749 2.078-25.531-.749.749-2.078c2.569-7.112 7.557-13.21 12.733-16.192z"
    />
    <path
      fill="#EDD14F"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M138.997 76.484c.065 0 .129.013.194.02h.038q.118.01.226.032a.2.2 0 0 1 .065.013c.052.006.103.02.155.026.026 0 .051.013.077.013.045.006.097.019.142.025.026 0 .058.013.084.02.045.006.084.019.129.032.032.006.058.013.091.02.038.012.083.019.122.032a.5.5 0 0 1 .09.025c.039.013.084.026.123.04.026.006.058.019.084.025q.066.02.123.039c.025.006.051.019.077.025.045.013.09.033.136.052.019.007.045.013.064.026l.194.077s.013 0 .019.007l.174.077c.02.013.046.02.065.032q.066.03.122.059.04.019.071.038l.117.058.077.04c.045.025.097.05.142.077l-41.49-24.118s-.052-.026-.078-.045c-.019-.013-.045-.026-.064-.039l-.078-.038-.116-.058q-.04-.02-.071-.04l-.123-.057c-.019-.013-.045-.02-.064-.032l-.174-.078s-.013 0-.02-.006l-.193-.078c-.02-.006-.046-.013-.065-.026-.045-.019-.09-.032-.135-.051-.026-.007-.052-.02-.078-.026l-.122-.039c-.026-.006-.058-.02-.084-.026l-.071-.019c-.02 0-.033-.006-.052-.013-.032-.006-.058-.02-.09-.026-.039-.013-.084-.019-.123-.032-.032-.006-.058-.013-.09-.02-.045-.012-.084-.019-.13-.031-.025 0-.057-.014-.083-.02-.045-.006-.09-.02-.142-.026-.026 0-.052-.013-.078-.013h-.019l-.142-.019c-.026 0-.045-.006-.071-.013-.077-.013-.148-.02-.226-.032h-.039l-.193-.02h-.084c-.045 0-.084-.006-.13-.012h-.019c-.09 0-.18-.013-.27-.013h-.723c-.058 0-.117 0-.175.013h-.077c-.071 0-.142.013-.213.019h-.032c-.084.006-.162.02-.246.026-.025 0-.045 0-.07.006-.059.007-.123.02-.181.026h-.078c-.09.013-.187.032-.277.045h-.032q-.124.022-.259.052a.2.2 0 0 0-.064.013c-.09.02-.187.038-.278.064q-.02-.002-.038.007c-.084.02-.168.045-.252.064-.013 0-.026 0-.039.013a.1.1 0 0 0-.038.013c-.033.006-.072.02-.104.026-.038.013-.07.02-.11.032-.032.013-.07.02-.103.032-.038.013-.07.02-.11.033-.032.013-.07.019-.103.032-.038.013-.07.026-.11.032a1 1 0 0 1-.103.032l-.11.04-.103.038c-.038.013-.07.026-.11.039-.032.013-.07.026-.103.038l-.11.04-.103.038a1 1 0 0 0-.11.045l-.103.039q-.03.01-.051.02c-.013 0-.032.012-.045.018-.052.02-.104.046-.155.065l-.084.039-.174.077c-.02.007-.046.02-.065.026-.077.039-.155.07-.232.11-.013.006-.032.013-.045.026l-.188.09a1 1 0 0 1-.084.038l-.154.078c-.033.013-.058.032-.09.045a3 3 0 0 0-.15.078c-.031.013-.057.032-.09.045a2 2 0 0 0-.16.09l-.078.039-.233.135c-.096.052-.187.11-.284.168-.025.02-.058.032-.084.052-.064.038-.135.084-.2.122q-.05.03-.09.058-.106.068-.213.136c-.026.013-.045.032-.07.045-.091.058-.188.123-.278.187q-.029.018-.065.046a4 4 0 0 1-.22.148c-.032.02-.057.045-.09.065q-.095.066-.2.142c-.032.019-.058.045-.09.064-.084.065-.168.123-.252.187-.006 0-.02.013-.026.02l-.277.212c-.026.02-.052.046-.084.065q-.096.078-.2.155c-.032.026-.058.052-.09.07q-.105.08-.2.169-.04.029-.072.058c-.09.077-.18.148-.27.226-.02.013-.033.032-.052.045-.071.064-.149.129-.22.194-.032.025-.058.051-.09.077-.064.058-.129.11-.187.168-.026.026-.058.051-.084.077a7 7 0 0 0-.265.252q-.137.126-.264.252c-.026.025-.052.045-.078.07-.064.065-.129.123-.193.188-.013.013-.032.026-.045.045l-.033.032q-.174.173-.348.355-.031.03-.052.058c-.122.123-.239.252-.361.374-.007.007-.013.02-.026.026-.116.13-.239.258-.355.388-.013.012-.02.025-.032.032q-.175.192-.349.393c-.013.013-.02.026-.032.04-.006.012-.02.018-.026.031-.09.104-.174.207-.264.31-.007.013-.02.02-.026.032a9 9 0 0 1-.239.284 1 1 0 0 1-.077.09c-.071.085-.136.169-.207.252-.02.026-.039.046-.058.072-.084.11-.168.212-.252.322 0 .007-.013.013-.013.02-.019.025-.038.045-.051.07-.052.065-.103.136-.155.2-.026.04-.058.072-.084.11-.045.065-.097.13-.142.194-.026.039-.058.077-.084.11-.052.07-.097.135-.148.206q-.04.047-.071.103-.098.134-.194.278c-.006.006-.013.02-.02.026a8 8 0 0 0-.2.29c-.019.026-.038.058-.057.084-.046.071-.097.142-.142.213l-.078.116c-.039.065-.084.123-.122.187-.026.039-.052.084-.084.123l-.117.174c-.006.013-.019.026-.025.045a.1.1 0 0 1-.026.04c-.11.173-.22.354-.33.528-.012.02-.025.045-.038.065-.11.174-.213.355-.323.535 0 .013-.013.02-.02.033q-.007.02-.025.038-.153.262-.297.523-.02.04-.038.071-.146.263-.29.536c0 .013-.014.02-.014.032l-.02.045a14 14 0 0 0-.309.6q-.135.27-.271.549c0 .007-.007.013-.013.02-.02.044-.045.09-.064.135-.026.052-.046.097-.072.148a4 4 0 0 1-.077.168c-.02.045-.045.097-.064.142l-.078.174c-.02.045-.045.097-.064.142l-.078.181q-.028.066-.064.142s0 .013-.007.013c-.02.052-.045.097-.064.148-.026.052-.046.11-.071.162-.026.051-.046.11-.071.161-.02.052-.046.11-.065.161-.026.058-.045.11-.064.168-.02.052-.046.11-.065.162-.02.058-.045.11-.064.167-.02.052-.046.11-.065.162v.013l-.078.2q-.017.059-.045.11-.056.164-.122.328l41.509 24.124q.057-.165.123-.329a1 1 0 0 1 .045-.11q.038-.106.084-.213c.02-.051.039-.11.065-.161.019-.058.045-.11.064-.168l.065-.161c.019-.058.045-.11.064-.168.02-.052.046-.103.065-.155.026-.058.045-.11.071-.168.019-.051.045-.103.064-.154l.071-.168.058-.136.078-.18c.019-.046.045-.097.064-.142l.078-.175c.019-.045.045-.097.064-.142q.039-.088.078-.168c.026-.051.045-.096.071-.148q.04-.078.071-.155l.271-.548a22.8 22.8 0 0 1 .31-.6l.038-.072.291-.535a1 1 0 0 1 .039-.071c.096-.175.2-.349.296-.523q.018-.04.046-.071.156-.272.322-.536l.039-.07q.165-.27.329-.53c.019-.026.032-.051.052-.077l.116-.174c.026-.04.052-.084.084-.123.039-.065.084-.123.122-.187l.078-.116c.045-.071.097-.142.142-.213l.058-.084c.064-.097.135-.194.2-.29.006-.014.013-.02.019-.033.065-.09.129-.187.194-.278q.04-.046.071-.103c.052-.07.097-.135.148-.206.026-.039.058-.078.084-.11.045-.064.097-.13.142-.194.026-.038.058-.07.084-.11.052-.064.103-.135.155-.2.026-.032.045-.064.071-.09.084-.11.168-.213.252-.322.019-.026.038-.046.058-.071.071-.084.135-.168.206-.252.026-.032.052-.058.078-.09.077-.097.155-.188.239-.284.006-.013.019-.02.025-.033.091-.103.175-.206.265-.31.019-.025.039-.045.058-.07.116-.13.232-.265.349-.394.012-.013.019-.026.032-.032q.172-.194.355-.388c.006-.006.013-.019.026-.025a9 9 0 0 1 .361-.375c.019-.02.039-.038.052-.058.116-.116.232-.239.348-.355l.078-.077c.064-.065.129-.123.193-.187a1 1 0 0 1 .078-.071c.09-.084.174-.168.264-.252l.039-.039c.077-.07.148-.142.226-.206.026-.026.058-.052.084-.078l.187-.167c.032-.026.058-.052.09-.078.071-.065.149-.129.22-.194.019-.013.032-.032.051-.045.091-.077.181-.155.271-.226q.04-.028.071-.058c.065-.058.136-.11.2-.167.033-.026.058-.052.091-.072a5 5 0 0 1 .2-.154c.026-.02.051-.045.084-.065a10 10 0 0 1 .303-.232c.084-.065.168-.123.252-.187.032-.02.058-.046.09-.065.065-.045.129-.097.2-.142.032-.02.058-.045.09-.064a4 4 0 0 1 .22-.149q.028-.018.064-.045c.091-.065.188-.123.278-.187.026-.013.045-.032.071-.045l.213-.136.097-.058.2-.123c.026-.019.058-.032.084-.051.096-.058.187-.11.284-.168l.232-.135.077-.04c.052-.031.11-.057.162-.09.032-.012.058-.032.09-.045q.079-.038.149-.077c.032-.013.058-.032.09-.045l.155-.078.084-.039c.064-.032.122-.064.187-.09.013-.006.032-.013.045-.026.077-.038.155-.07.232-.11.02-.012.045-.019.065-.025l.174-.078c.026-.013.058-.025.084-.038.052-.02.103-.046.148-.065l.097-.039c.032-.013.071-.025.103-.038a1 1 0 0 0 .11-.046c.032-.013.071-.025.103-.038l.11-.039.103-.039c.039-.013.071-.026.11-.038.032-.013.071-.026.103-.04.039-.012.071-.025.11-.038a1 1 0 0 1 .103-.032c.039-.013.071-.026.11-.032.032-.013.071-.02.103-.033.039-.013.071-.02.11-.032.032-.013.071-.02.103-.032.039-.013.071-.02.11-.032.032-.007.065-.02.103-.026l.078-.02c.084-.02.168-.045.251-.064q.02.002.039-.007c.09-.02.187-.045.278-.064.025 0 .045-.007.071-.013.084-.02.167-.032.258-.052h.032c.09-.02.187-.032.278-.045a.3.3 0 0 0 .077-.013c.058-.006.123-.02.181-.026.026 0 .045 0 .071-.006a3 3 0 0 1 .245-.026h.032l.213-.02h.078q.087-.001.174-.012h.723q.135.001.271.013c.051 0 .097.006.148.013h.084z"
    />
    <path
      fill="#70C0DB"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="m144.574 95.355-.749 2.078-25.531-.749.749-2.078z"
    />
  </svg>
);
